import { Component, Inject, OnInit } from '@angular/core';
import { Evidence } from '../../audit.model';
import { EvidenceService } from '../../evidence.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';

@Component({
  selector: 'iaud-evidence-add-dialog',
  templateUrl: './evidence-add-dialog.component.html',
  styleUrls: ['./evidence-add-dialog.component.scss']
})
export class EvidenceAddDialogComponent implements OnInit {

  evidence: Evidence;
  capaId: number;
  isNew: boolean;
  isFormValid: boolean;
  file: File;
  formData: FormData;

  constructor(
    private evidenceService: EvidenceService,
    public dialogRef: MatDialogRef<EvidenceAddDialogComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.evidence = data.evidence;
    this.capaId = data.capaId;
  }

  ngOnInit(): void {
    this.isNew = this.evidence == null;
    if (this.isNew) {
      this.evidence = {
        capaId: this.capaId,
      };
    }
  }
  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }
  setFormData(formData: FormData): void {
    this.formData = formData;
  }
  fileChanged(file: File): void {
    this.file = file;
  }
  update(): void {
    if (this.isNew) {
      const formData: FormData = new FormData();
      formData.append('file', this.file);
      if (this.evidence.description) {
        this.evidence.description = this.evidence.description.trim();
        if (this.evidence.description !== '') {
          formData.append('description', this.evidence.description);
        }
      }
      formData.append('capaId', this.capaId.toString());
      this.evidenceService.submitEvidence(formData)
        .subscribe(response => {
          this.dialogRef.close({ evidenceId: response, success: true });
        }, error => {
          this.snackBar.open(`Error Create/Update Evidence: ${error.error.error.message}`, 'Ok', {
            duration: 4000,
          });
        });
    } else {
      const formData: FormData = new FormData();
      formData.append('file', this.file);
      if (this.evidence.description) {
        this.evidence.description = this.evidence.description.trim();
        if (this.evidence.description !== '') {
          formData.append('description', this.evidence.description);
        }
      }
      if (this.evidence.fileName) {
        formData.append('fileName', this.evidence.fileName);
      }
      formData.append('capaId', this.capaId.toString());
      formData.append('id', this.evidence.id.toString())
      this.evidenceService.updateEvidence(this.evidence.id, formData)
        .subscribe(response => {
          this.dialogRef.close({ evidenceId: response, success: true });
        }, error => {
          this.snackBar.open(`Error Create/Update Evidence: ${error.error.error.message}`, 'Ok', {
            duration: 4000,
          });
        });
    }
  }
}
